import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: null,
  insights: null,
  snapshot: null,
  sessions: [],
  sessionsLoading: false,
};

const slice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setInsights(state, action) {
      state.isLoading = false;
      state.insights = action.payload;
    },
    setSnapshot(state, action) {
      state.isLoading = false;
      state.snapshot = action.payload;
    },
    startSessionsLoading(state) {
      state.sessionsLoading = true;
    },
    setSessionsList(state, action) {
      state.sessionsLoading = false;
      state.sessions = action.payload;
    },
  },
});

export default slice.reducer;
export const { setInsights, setSnapshot } = slice.actions;

// ----------------------------------------------------------------------

export function fetchInsights() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${process.env.REACT_APP_HOST_API}/insights/me`);
      dispatch(slice.actions.setInsights(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.error?.message || 'Analytics/FetchInsights/InternalError'));
    }
  };
}

export function generateInsights() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${process.env.REACT_APP_HOST_API}/insights/me/generate`);
      dispatch(slice.actions.setInsights(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.error?.message || 'Analytics/GenerateInsights/InternalError'));
    }
  };
}

export function fetchLatestSnapshot() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_HOST_API}/progress-snapshots/me/latest`);
      dispatch(slice.actions.setSnapshot(response.data.data));
    } catch (error) {
      // 404 is expected for users with no data — silently ignore
      if (error?.response?.status !== 404) {
        dispatch(slice.actions.hasError(error?.error?.message || 'Analytics/FetchSnapshot/InternalError'));
      }
    }
  };
}

export function fetchRecentSessions(userId) {
  return async (dispatch) => {
    dispatch(slice.actions.startSessionsLoading());
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_HOST_API}/practices/user/${userId}`,
        { params: { limit: 10, status: 'completed', sortBy: 'completedAt', order: 'desc' } }
      );
      dispatch(slice.actions.setSessionsList(response.data.data.items || []));
    } catch (error) {
      dispatch(slice.actions.setSessionsList([]));
    }
  };
}
